import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {MeetingComponent} from './meeting/meeting.component';
import {ServiziComponent} from './servizi/servizi.component';

const routes: Routes = [

  {
    path: 'meeting',
    component: MeetingComponent
  },   {
    path: '',
    component: LoginComponent, // another child route component that the router renders
  },
  {
    path: 'servizi',
    component: ServiziComponent
  }

];
@NgModule({

  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
